export default __webpack_public_path__ + "static/media/UfT-gray.194866ae.png";